{
    "name": "02 fruit smasher",
    "title": "FruitSmasher",
    "description": "FruitSmasherDescription",
    "stat": 5,
    "boughtEarlyStat": 51,
    "inventoryStat": 19,
    "lockFlag": 13
}
